import { useState, useEffect } from 'react';
import TeamService from '../views/Team/service';

export function useGetUserTeams() {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const login = localStorage.getItem('login');

    if (login) {
      TeamService.getAllTeamsByUser(login)
        .then((response) => {
          setTeams(response.data.data);
        })
        .catch((err) => {
          console.log('err: ' + err);
        });
    } else {
      setTeams([]);
    }
  }, []);

  return {
    teams,
    setTeams
  };
}
